export const ROUTES_CONFIG = {
    SEO_GRATIS: {
        priority: "0.8",
        changefreq: "monthly",
        paths: {
            pt: "/teleprompter-online-gratis",
            en: "/en/free-online-teleprompter",
            es: "/es/teleprompter-online-gratis",
        },
        images: [
            {
                slug: "teleprompter-online-gratis",
                src: "teleprompter-showcase-multi-device.webp",
                titles: {
                    pt: "Teleprompter online grátis em múltiplos dispositivos",
                    en: "Free online teleprompter on multiple devices",
                    es: "Teleprompter online gratis en múltiples dispositivos"
                }
            },
            {
                slug: "teleprompter-online-gratis",
                src: "free-online-teleprompter-monitors.webp",
                titles: {
                    pt: "Interface do teleprompter para monitores profissionais",
                    en: "Teleprompter interface for professional monitors",
                    es: "Interfaz de teleprompter para monitores profesionales"
                }
            }
        ]
    },
    SEO_TUTORIAL: {
        priority: "0.8",
        changefreq: "monthly",
        paths: {
            pt: "/como-usar-teleprompter-celular",
            en: "/en/how-to-use-teleprompter-mobile",
            es: "/es/como-usar-teleprompter-movil",
        },
        images: [
            {
                slug: "como-usar-teleprompter-celular",
                src: "how-to-use-teleprompter-cell-phone-recording.webp",
                titles: {
                    pt: "Como usar teleprompter no celular para gravações",
                    en: "How to use teleprompter on mobile for recordings",
                    es: "Cómo usar teleprompter en el celular para grabaciones"
                }
            }
        ]
    },
    SEO_MELHOR_APP: {
        priority: "0.8",
        changefreq: "monthly",
        paths: {
            pt: "/melhor-teleprompter-app",
            en: "/en/best-teleprompter-app",
            es: "/es/mejor-app-teleprompter",
        },
        images: [
            {
                slug: "melhor-teleprompter-app",
                src: "best-app-teleprompter-interface-ui.webp",
                titles: {
                    pt: "Interface premium do melhor app de teleprompter",
                    en: "Premium interface of the best teleprompter app",
                    es: "Interfaz premium de la mejor app de teleprompter"
                }
            }
        ]
    },
    SEO_ALTERNATIVAS: {
        priority: "0.8",
        changefreq: "monthly",
        paths: {
            pt: "/alternativas-teleprompter-concorrente",
            en: "/en/teleprompter-alternatives",
            es: "/es/alternativas-teleprompter",
        },
        images: [
            {
                slug: "alternativas-teleprompter-concorrente",
                src: "alternative-teleprompter-professional.webp",
                titles: {
                    pt: "Alternativa profissional ao teleprompter convencional",
                    en: "Professional alternative to conventional teleprompter",
                    es: "Alternativa profesional al teleprompter convencional"
                }
            }
        ]
    },
    SEO_YOUTUBERS: {
        priority: "0.8",
        changefreq: "monthly",
        paths: {
            pt: "/teleprompter-para-youtubers-e-criadores",
            en: "/en/teleprompter-for-youtubers-creators",
            es: "/es/teleprompter-para-youtubers-creadores",
        },
        images: [
            {
                slug: "teleprompter-para-youtubers-e-criadores",
                src: "teleprompter-for-youtubers-setup.webp",
                titles: {
                    pt: "Setup de teleprompter profissional para Youtubers",
                    en: "Professional teleprompter setup for Youtubers",
                    es: "Configuración de teleprompter profesional para Youtubers"
                }
            }
        ]
    },
    SEO_TRAVANDO: {
        priority: "0.8",
        changefreq: "monthly",
        paths: {
            pt: "/teleprompter-travando-solucao",
            en: "/en/teleprompter-freezing-solution",
            es: "/es/solucion-teleprompter-congelado",
        },
        images: [
            {
                slug: "teleprompter-travando-solucao",
                src: "teleprompter-solution-infographic.webp",
                titles: {
                    pt: "Infográfico de solução para teleprompter travando",
                    en: "Solution infographic for teleprompter freezing",
                    es: "Infografía de solución para teleprompter congelado"
                }
            }
        ]
    },
    SEO_DIY: {
        priority: "0.8",
        changefreq: "monthly",
        paths: {
            pt: "/teleprompter-caseiro-diy",
            en: "/en/diy-homemade-teleprompter",
            es: "/es/teleprompter-casero-diy",
        },
        images: [
            {
                slug: "teleprompter-caseiro-diy",
                src: "homemade-teleprompter-diy-setup.webp",
                titles: {
                    pt: "Setup de teleprompter caseiro (DIY)",
                    en: "DIY homemade teleprompter setup",
                    es: "Configuración de teleprompter casero (DIY)"
                }
            }
        ]
    },
    SEO_ORATORIA: {
        priority: "0.8",
        changefreq: "monthly",
        paths: {
            pt: "/dicas-oratoria-video",
            en: "/en/public-speaking-tips-video",
            es: "/es/consejos-oratoria-video",
        },
        images: [
            {
                slug: "dicas-oratoria-video",
                src: "public-speaking-video-confident-youtuber.webp",
                titles: {
                    pt: "Dicas de oratória para vídeos com confiança",
                    en: "Public speaking tips for confident videos",
                    es: "Consejos de oratoria para videos con confianza"
                }
            }
        ]
    },
    SEO_DECORAR: {
        priority: "0.8",
        changefreq: "monthly",
        paths: {
            pt: "/como-decorar-texto-rapido",
            en: "/en/how-to-memorize-scripts-fast",
            es: "/es/como-memorizar-guiones-rapido",
        },
        images: [
            {
                slug: "como-decorar-texto-rapido",
                src: "how-to-memorize-text-quick-tablet.webp",
                titles: {
                    pt: "Como decorar textos rápido usando tablet",
                    en: "How to memorize scripts fast using a tablet",
                    es: "Cómo memorizar guiones rápido usando una tablet"
                }
            }
        ]
    },
    SEO_WEBRTC: {
        priority: "0.8",
        changefreq: "monthly",
        paths: {
            pt: "/tecnologia-webrtc-baixa-latencia",
            en: "/en/webrtc-low-latency-technology",
            es: "/es/tecnologia-webrtc-baja-latencia",
        },
        images: [
            {
                slug: "tecnologia-webrtc-baixa-latencia",
                src: "webrtc-technology-synchronization-devices.webp",
                titles: {
                    pt: "Tecnologia WebRTC para sincronização de baixa latência",
                    en: "WebRTC technology for low latency synchronization",
                    es: "Tecnología WebRTC para sincronización de baja latencia"
                }
            }
        ]
    },
    SEO_PC_WINDOWS: {
        priority: "0.8",
        changefreq: "monthly",
        paths: {
            pt: "/teleprompter-pc-windows",
            en: "/en/teleprompter-pc-windows",
            es: "/es/teleprompter-pc-windows",
        },
        images: [
            {
                slug: "teleprompter-pc-windows",
                src: "teleprompter-pc-windows-setup.webp",
                titles: {
                    pt: "Teleprompter profissional para PC e Windows",
                    en: "Professional teleprompter for PC and Windows",
                    es: "Teleprompter profesional para PC y Windows"
                }
            }
        ]
    },
    SEO_ZOOM: {
        priority: "0.8",
        changefreq: "monthly",
        paths: {
            pt: "/teleprompter-zoom-meeting",
            en: "/en/teleprompter-zoom-meeting",
            es: "/es/teleprompter-zoom-meeting",
        },
        images: [
            {
                slug: "teleprompter-zoom-meeting",
                src: "teleprompter-zoom-meeting-transparent.webp",
                titles: {
                    pt: "Teleprompter transparente para reuniões no Zoom",
                    en: "Transparent teleprompter for Zoom meetings",
                    es: "Teleprompter transparente para reuniones en Zoom"
                }
            }
        ]
    },
    SEO_TIKTOK: {
        priority: "0.8",
        changefreq: "monthly",
        paths: {
            pt: "/teleprompter-tiktok-shorts",
            en: "/en/teleprompter-tiktok-shorts",
            es: "/es/teleprompter-tiktok-shorts",
        },
        images: [
            {
                slug: "teleprompter-tiktok-shorts",
                src: "teleprompter-tiktok-reels-vertical.webp",
                titles: {
                    pt: "Teleprompter vertical para TikTok e Reels",
                    en: "Vertical teleprompter for TikTok and Reels",
                    es: "Teleprompter vertical para TikTok y Reels"
                }
            }
        ]
    },
    SEO_OBS: {
        priority: "0.8",
        changefreq: "monthly",
        paths: {
            pt: "/teleprompter-obs-studio",
            en: "/en/teleprompter-obs-studio",
            es: "/es/teleprompter-obs-studio",
        },
    },
    SEO_CAPCUT: {
        priority: "0.8",
        changefreq: "monthly",
        paths: {
            pt: "/teleprompter-capcut",
            en: "/en/teleprompter-capcut",
            es: "/es/teleprompter-capcut",
        },
    },
    SEO_HARDWARE_VS_WEB: {
        priority: "0.8",
        changefreq: "monthly",
        paths: {
            pt: "/teleprompter-web-vs-hardware",
            en: "/en/teleprompter-web-vs-hardware-comparison",
            es: "/es/comparativa-teleprompter-web-vs-hardware",
        },
    },
    SEO_MEET_TEAMS: {
        priority: "0.8",
        changefreq: "monthly",
        paths: {
            pt: "/teleprompter-google-meet-teams",
            en: "/en/teleprompter-google-meet-teams",
            es: "/es/teleprompter-google-meet-teams",
        },
    },
    SEO_IPHONE_IPAD: {
        priority: "0.8",
        changefreq: "monthly",
        paths: {
            pt: "/teleprompter-iphone-ipad",
            en: "/en/teleprompter-for-iphone-ipad",
            es: "/es/teleprompter-para-iphone-ipad",
        },
    },
    SEO_APRESENTACOES: {
        priority: "0.8",
        changefreq: "monthly",
        paths: {
            pt: "/teleprompter-apresentacoes",
            en: "/en/teleprompter-for-presentations",
            es: "/es/teleprompter-para-presentaciones",
        },
        images: [
            {
                slug: "teleprompter-apresentacoes",
                src: "teleprompter-presentations-corporate-speaker.webp",
                titles: {
                    pt: "Teleprompter para apresentações e palestras corporativas",
                    en: "Teleprompter for presentations and corporate speaking",
                    es: "Teleprompter para presentaciones y charlas corporativas"
                }
            }
        ]
    },
    SEO_PWA_INSTALL: {
        priority: "0.8",
        changefreq: "monthly",
        paths: {
            pt: "/como-instalar-app-teleprompter-pwa",
            en: "/en/how-to-install-teleprompter-app-pwa",
            es: "/es/como-instalar-app-teleprompter-pwa",
        },
    },
    SEO_PRIVACY: {
        priority: "0.8",
        changefreq: "monthly",
        paths: {
            pt: "/teleprompter-privacidade-seguranca",
            en: "/en/teleprompter-privacy-security",
            es: "/es/teleprompter-privacidad-seguridad",
        },
    },
    SEO_SCRIPTS: {
        priority: "0.9",
        changefreq: "weekly",
        paths: {
            pt: "/scripts-teleprompter",
            en: "/en/teleprompter-scripts",
            es: "/es/guiones-teleprompter",
        },
        images: [
            {
                slug: "scripts-teleprompter",
                src: "teleprompter-scripts-writing-guide.webp",
                titles: {
                    pt: "Guia de escrita de scripts para teleprompter",
                    en: "Script writing guide for teleprompter",
                    es: "Guía de escritura de guiones para teleprompter"
                }
            }
        ]
    },
    SEO_SCRIPTS_YOUTUBE: {
        priority: "0.9",
        changefreq: "weekly",
        paths: {
            pt: "/scripts-para-youtube",
            en: "/en/scripts-for-youtube",
            es: "/es/guiones-para-youtube",
        },
    },
    SEO_SCRIPTS_TIKTOK: {
        priority: "0.9",
        changefreq: "weekly",
        paths: {
            pt: "/scripts-para-tiktok-reels",
            en: "/en/scripts-for-tiktok-shorts",
            es: "/es/guiones-para-tiktok-shorts",
        },
    },
    SEO_SCRIPTS_SALES: {
        priority: "0.9",
        changefreq: "weekly",
        paths: {
            pt: "/scripts-para-vendas",
            en: "/en/scripts-for-sales",
            es: "/es/guiones-para-ventas",
        },
        images: [
            {
                slug: "scripts-para-vendas",
                src: "scripts-for-sales-pitch.webp",
                titles: {
                    pt: "Scripts de vendas persuasivos para teleprompter",
                    en: "Persuasive sales scripts for teleprompter",
                    es: "Guiones de ventas persuasivos para teleprompter"
                }
            }
        ]
    },
    SEO_SCRIPTS_CLASSES: {
        priority: "0.9",
        changefreq: "weekly",
        paths: {
            pt: "/scripts-para-aulas",
            en: "/en/scripts-for-classes",
            es: "/es/guiones-para-clases",
        },
        images: [
            {
                slug: "scripts-para-aulas",
                src: "scripts-for-teacher-lessons.webp",
                titles: {
                    pt: "Scripts para aulas e educação online",
                    en: "Scripts for online lessons and education",
                    es: "Guiones para clases y educación online"
                }
            }
        ]
    },
    SEO_SCRIPTS_INSTITUTIONAL: {
        priority: "0.9",
        changefreq: "weekly",
        paths: {
            pt: "/scripts-institucionais",
            en: "/en/institutional-scripts",
            es: "/es/guiones-institucionales",
        },
        images: [
            {
                slug: "scripts-institucionais",
                src: "corporate-institutional-scripts.webp",
                titles: {
                    pt: "Scripts institucionais para vídeos corporativos",
                    en: "Institutional scripts for corporate videos",
                    es: "Guiones institucionales para videos corporativos"
                }
            }
        ]
    },
    SEO_O_QUE_E: {
        priority: "0.8",
        changefreq: "monthly",
        paths: {
            pt: "/teleprompter-o-que-e",
            en: "/en/teleprompter-what-is-it",
            es: "/es/teleprompter-que-es",
        },
        images: [
            {
                slug: "teleprompter-o-que-e",
                src: "what-is-a-teleprompter-explanation.webp",
                titles: {
                    pt: "O que é um teleprompter e como funciona",
                    en: "What is a teleprompter and how it works",
                    es: "¿Qué es un teleprompter y cómo funciona?"
                }
            }
        ]
    },
    SEO_MODO_MUSICO: {
        priority: "0.8",
        changefreq: "monthly",
        paths: {
            pt: "/teleprompter-modo-musico",
            en: "/en/teleprompter-musician-mode",
            es: "/es/teleprompter-modo-musico",
        },
        images: [
            {
                slug: "teleprompter-modo-musico",
                src: "teleprompter-music-mode-lyrics-chords.webp",
                titles: {
                    pt: "Teleprompter em modo músico com cifras e letras",
                    en: "Teleprompter in musician mode with chords and lyrics",
                    es: "Teleprompter en modo músico con acordes y letras"
                }
            }
        ]
    },
    SEO_PACING: {
        priority: "0.9",
        changefreq: "monthly",
        paths: {
            pt: "/teleprompter-pacing-timer-online",
            en: "/en/teleprompter-pacing-timer-online",
            es: "/es/teleprompter-pacing-timer-online",
        },
    },
    SEO_SHORTCUTS: {
        priority: "0.9",
        changefreq: "monthly",
        paths: {
            pt: "/teleprompter-com-atalhos-de-teclado",
            en: "/en/teleprompter-keyboard-shortcuts",
            es: "/es/teleprompter-atajos-teclado",
        },
        images: [
            {
                slug: "teleprompter-com-atalhos-de-teclado",
                src: "teleprompter-shortcuts-keyboard-speed.webp",
                titles: {
                    pt: "Atalhos de teclado para controle de teleprompter",
                    en: "Keyboard shortcuts for teleprompter control",
                    es: "Atajos de teclado para el control del teleprompter"
                }
            }
        ]
    },
    SEO_GAMER: {
        priority: "0.9",
        changefreq: "monthly",
        paths: {
            pt: "/teleprompter-gamers-streaming",
            en: "/en/teleprompter-gamers-streaming",
            es: "/es/teleprompter-gamers-streaming",
        },
        images: [
            {
                slug: "teleprompter-gamers-streaming",
                src: "teleprompter-gamers-streaming-interface.webp",
                titles: {
                    pt: "Interface de teleprompter para gamers e streamers",
                    en: "Teleprompter interface for gamers and streamers",
                    es: "Interfaz de teleprompter para gamers y streamers"
                }
            }
        ]
    },
    SEO_SLIDES_SYNC: {
        priority: "0.9",
        changefreq: "monthly",
        paths: {
            pt: "/teleprompter-sincronizar-powerpoint-slides",
            en: "/en/teleprompter-sync-powerpoint-slides",
            es: "/es/teleprompter-sincronizar-powerpoint-slides",
        },
        images: [
            {
                slug: "teleprompter-sincronizar-powerpoint-slides",
                src: "teleprompter-synchronization-powerpoint-slides.webp",
                titles: {
                    pt: "Sincronização de teleprompter com PowerPoint e slides",
                    en: "Teleprompter synchronization with PowerPoint and slides",
                    es: "Sincronización del teleprompter con PowerPoint y diapositivas"
                }
            }
        ]
    },
    SEO_TABLET: {
        priority: "0.9",
        changefreq: "monthly",
        paths: {
            pt: "/teleprompter-para-tablet-ipad-android",
            en: "/en/teleprompter-app-for-tablet-ipad",
            es: "/es/teleprompter-para-tablet-ipad-android",
        },
        images: [
            {
                slug: "teleprompter-para-tablet-ipad-android",
                src: "teleprompter-tablet-ipad-android-use.webp",
                titles: {
                    pt: "Uso de app de teleprompter em tablets e iPads",
                    en: "Using teleprompter app on tablets and iPads",
                    es: "Uso de la app de teleprompter en tablets e iPads"
                }
            }
        ]
    },
    SEO_MODO_BILINGUE: {
        priority: "0.9",
        changefreq: "monthly",
        paths: {
            pt: "/teleprompter-modo-bilingue",
            en: "/en/teleprompter-bilingual-mode",
            es: "/es/teleprompter-modo-bilingue",
        },
        images: [
            {
                slug: "teleprompter-modo-bilingue",
                src: "Teleprompter.webp",
                titles: {
                    pt: "Suporte bilingue avançado no teleprompter",
                    en: "Advanced bilingual support in the teleprompter",
                    es: "Soporte bilingüe avanzado en el teleprompter"
                }
            }
        ]
    },
    SEO_FITNESS: {
        priority: "0.9",
        changefreq: "monthly",
        paths: {
            pt: "/teleprompter-para-fitness-treino",
            en: "/en/teleprompter-for-fitness-workout",
            es: "/es/teleprompter-para-fitness-entrenamiento",
        },
        images: [
            {
                slug: "teleprompter-para-fitness-treino",
                src: "teleprompter-fitness-treino-coach.webp",
                titles: {
                    pt: "Teleprompter para instrutores de fitness e treinos",
                    en: "Teleprompter for fitness instructors and workouts",
                    es: "Teleprompter para instructores de fitness y entrenamientos"
                }
            }
        ]
    },
    SEO_HUB_GUIDE: {
        priority: "1.0",
        changefreq: "weekly",
        paths: {
            pt: "/guia-completo-teleprompter",
            en: "/en/ultimate-teleprompter-guide",
            es: "/es/guia-definitiva-teleprompter",
        },
        images: [
            {
                slug: "guia-completo-teleprompter",
                src: "complete-guide-teleprompter-everything-about.webp",
                titles: {
                    pt: "Guia completo e definitivo sobre teleprompter",
                    en: "The ultimate complete guide to teleprompter",
                    es: "La guía completa y definitiva sobre teleprompter"
                }
            }
        ]
    },
    SEO_VS_TELELESTRADOR: {
        priority: "0.8",
        changefreq: "monthly",
        paths: {
            pt: "/teleprompter-vs-telelestrador",
            en: "/en/teleprompter-vs-telelestrador",
            es: "/es/teleprompter-vs-telelestrador",
        },
    },
    SEO_HISTORY: {
        priority: "0.8",
        changefreq: "weekly",
        paths: {
            pt: "/historia-do-teleprompter",
            en: "/en/history-of-teleprompter",
            es: "/es/historia-del-teleprompter",
        },
    },
    SEO_CELEBRITIES: {
        priority: "0.8",
        changefreq: "monthly",
        paths: {
            pt: "/celebridades-usam-teleprompter",
            en: "/en/celebrities-use-teleprompter",
            es: "/es/famosos-usan-teleprompter",
        },
    },
    SEO_COMMON_MISTAKES: {
        priority: "0.9",
        changefreq: "monthly",
        paths: {
            pt: "/erros-comuns-teleprompter",
            en: "/en/common-teleprompter-mistakes",
            es: "/es/errores-comunes-teleprompter",
        },
    },
    SEO_BUYING_GUIDE: {
        priority: "0.8",
        changefreq: "weekly",
        paths: {
            pt: "/como-escolher-teleprompter",
            en: "/en/how-to-choose-teleprompter",
            es: "/es/como-elegir-teleprompter",
        },
    },
    SEO_LIVES: {
        priority: "0.8",
        changefreq: "monthly",
        paths: {
            pt: "/teleprompter-para-lives",
            en: "/en/teleprompter-for-live-streaming",
            es: "/es/teleprompter-para-directos",
        },
    },
    SEO_PODCAST: {
        priority: "0.8",
        changefreq: "monthly",
        paths: {
            pt: "/teleprompter-para-podcast",
            en: "/en/teleprompter-for-podcast",
            es: "/es/teleprompter-para-podcast",
        },
    },
    SEO_READING_SPEED: {
        priority: "0.8",
        changefreq: "weekly",
        paths: {
            pt: "/velocidade-leitura-teleprompter",
            en: "/en/teleprompter-reading-speed",
            es: "/es/velocidad-lectura-teleprompter",
        },
        images: [
            {
                slug: "velocidade-leitura-teleprompter",
                src: "reading-speed-teleprompter-adjustment.webp",
                titles: {
                    pt: "Controle e ajuste de velocidade de leitura no teleprompter",
                    en: "Reading speed control and adjustment in the teleprompter",
                    es: "Control y ajuste de velocidad de lectura en el teleprompter"
                }
            }
        ]
    },
    SEO_ACCESSIBILITY: {
        priority: "0.8",
        changefreq: "weekly",
        paths: {
            pt: "/teleprompter-acessibilidade",
            en: "/en/teleprompter-accessibility",
            es: "/es/teleprompter-accesibilidad",
        },
    },
    SEO_FUTURE_AI: {
        priority: "0.8",
        changefreq: "weekly",
        paths: {
            pt: "/futuro-teleprompters-ai",
            en: "/en/future-teleprompters-ai",
            es: "/es/futuro-teleprompters-ai",
        },
    },
    SEO_EVENTOS: {
        priority: "0.9",
        changefreq: "monthly",
        paths: {
            pt: "/teleprompter-para-eventos-profissionais",
            en: "/en/teleprompter-for-professional-events",
            es: "/es/teleprompter-para-eventos-profesionales",
        },
    },
    SEO_CHECKLIST: {
        priority: "0.9",
        changefreq: "monthly",
        paths: {
            pt: "/checklist-gravacao-teleprompter-perfeita",
            en: "/en/perfect-teleprompter-recording-checklist",
            es: "/es/checklist-grabacion-teleprompter-perfecta",
        },
    },
};
